var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c(
          "a",
          {
            staticClass: "active",
            attrs: {
              href:
                "/tjkStudy/operatorExamine?groupId=" +
                _vm.groupId +
                "&groupName=" +
                _vm.groupName,
              target: "_blank"
            }
          },
          [_vm._v("群培训管理")]
        ),
        _vm._v(">\n    "),
        _c("span", [_vm._v("语音考核")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "end" },
        [
          _c("span", [_vm._v("当前拨打电话：" + _vm._s(_vm.callPhone))]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "danger" },
              on: {
                click: function($event) {
                  return _vm.endExam()
                }
              }
            },
            [_vm._v("结束考核")]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.currentExamRecord
        ? [
            _c("p", { staticClass: "nopeople" }, [
              _vm._v("名单中全部人员考核结束")
            ])
          ]
        : [
            _c("div", { staticClass: "current" }, [
              _c("div", { staticClass: "content" }, [
                _c("table", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v(_vm._s(_vm.realName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.loginName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.tjkNumber))]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.passState,
                              callback: function($$v) {
                                _vm.passState = $$v
                              },
                              expression: "passState"
                            }
                          },
                          [
                            _c("el-option", {
                              key: "Passed",
                              attrs: { label: "通过", value: "Passed" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              key: "Failed",
                              attrs: { label: "未通过", value: "Failed" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              key: "NotExamine",
                              attrs: { label: "未考", value: "NotExamine" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              key: "Loss",
                              attrs: { label: "流失", value: "Loss" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              key: "Cancel",
                              attrs: { label: "取消资格", value: "Cancel" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("el-input", {
                          attrs: { placeholder: "只能填写数字", clearable: "" },
                          model: {
                            value: _vm.score,
                            callback: function($$v) {
                              _vm.score = _vm._n($$v)
                            },
                            expression: "score"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: "",
                            placeholder: "不能超过200字",
                            clearable: ""
                          },
                          model: {
                            value: _vm.remark,
                            callback: function($$v) {
                              _vm.remark = $$v
                            },
                            expression: "remark"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.saveScore }
                          },
                          [_vm._v("保存打分")]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ],
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c("h3", [_vm._v("考核名单")]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.list, border: "" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "sequence",
                          label: "顺序",
                          width: "60",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "loginName",
                          label: "电话",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.passState == "Passed"
                                  ? _c("span", [_vm._v("通过")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Failed"
                                  ? _c("span", [_vm._v("未通过")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "NotExamine"
                                  ? _c("span", [_vm._v("未考")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Loss"
                                  ? _c("span", [_vm._v("流失")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Cancel"
                                  ? _c("span", [_vm._v("取消资格")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "score",
                          label: "综合得分",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "remark",
                          label: "备注",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "isFinish",
                          label: "是否完成考核",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.isFinish == "No"
                                  ? _c("span", [_vm._v("否")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.isFinish == "Yes"
                                  ? _c("span", [_vm._v("是")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("考核人员")]),
      _vm._v(" "),
      _c("th", [_vm._v("电话")]),
      _vm._v(" "),
      _c("th", [_vm._v("淘金号")]),
      _vm._v(" "),
      _c("th", [_vm._v("是否通过")]),
      _vm._v(" "),
      _c("th", [_vm._v("综合得分")]),
      _vm._v(" "),
      _c("th", [_vm._v("备注")]),
      _vm._v(" "),
      _c("th")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-512b85b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-512b85b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/provider/enterExam.vue
// module id = 1202
// module chunks = 0